import Stickyfill from 'stickyfilljs';

const stickyBar = document.querySelector('.js-sticky-sidebar');

const stickySidebar = function() {
  if (stickyBar === null) {
    return;
  }

  Stickyfill.add(stickyBar);
};

export default stickySidebar;



// WEBPACK FOOTER //
// ./src/scripts/modules/sticky-sidebar.js